import {TreatmentTarget} from './treatment_target'
import {TreatmentFlow} from './treatment'
import {WebhookTreatment} from './webhook'
import {RepCodeTreatment} from './rep_code'

export class PostCallTreatment extends HTMLElement{
  constructor() {
    super();
  }

  selectOption(option) {
    let optionsContainer = this.querySelector(".post_menu_options");
    optionsContainer.children.forEach((item, index) => {item.setSelected(false)});
    option.setSelected(true);
    this.querySelector(":scope > .option_path .option_text").innerText = option.querySelector("select option:checked").text;
    this.querySelectorAll(':scope > post-treatment-flow').forEach((item, index) => {item.style.cssText = 'display: none;'})

    this.querySelectorAll(':scope > post-treatment-flow')[Array.prototype.indexOf.call(optionsContainer.children, option)].style.cssText = 'display:block;';
    this.querySelector(".option_path").style = "display:block;"
  }

  removeOption(option) {
    let optionsContainer = this.querySelector(".post_menu_options");
    this.querySelectorAll(':scope > post-treatment-flow')[Array.prototype.indexOf.call(optionsContainer.children, option)].remove();
    let selectFirstOption = !option.hidden;
    option.remove();

    if(selectFirstOption && optionsContainer.children.length > 0) this.selectOption(optionsContainer.children[0])

    if(optionsContainer.children.length <= 0) {
      this.querySelector(".option_path").style = "display:none;"
    }
  }

  flowTimingChange(option, new_timing) {
    let optionsContainer = this.querySelector(".post_menu_options");
    let treatment_flow = this.querySelectorAll(':scope > post-treatment-flow')[Array.prototype.indexOf.call(optionsContainer.children, option)];
    let child_changes_required = false;

    if(!PostTreatmentElement.ACTION_TIMING_MAP.SMS.includes(new_timing) && treatment_flow.querySelectorAll("sms-treatment").length > 0) {
      child_changes_required = true;
    } else if(!PostTreatmentElement.ACTION_TIMING_MAP.PLAY_AUDIO.includes(new_timing) && treatment_flow.querySelectorAll("audio-action-treatment").length > 0 ) {
      child_changes_required = true;
    } else if(!PostTreatmentElement.ACTION_TIMING_MAP.WEBHOOK.includes(new_timing) && treatment_flow.querySelectorAll("webhook-treatment").length > 0) {
      child_changes_required = true;
    } else if(!PostTreatmentElement.ACTION_TIMING_MAP.REP_CODE.includes(new_timing) && treatment_flow.querySelectorAll("rep-code-treatment").length > 0) {
      child_changes_required = true;
    }
      


    if(child_changes_required) {
      let continute_with_change = confirm("Changing the timing will effect some of the existing actions.");
      if(continute_with_change) {
        if(!PostTreatmentElement.ACTION_TIMING_MAP.SMS.includes(new_timing)) {
          treatment_flow.querySelectorAll("sms-treatment").forEach(function(element) {
            element.parentNode.removeChild(element);
          });
        } 
        if(!PostTreatmentElement.ACTION_TIMING_MAP.PLAY_AUDIO.includes(new_timing)) {
          treatment_flow.querySelectorAll("audio-action-treatment").forEach(function(element) {
            element.parentNode.removeChild(element);
          });
        } 
        if(!PostTreatmentElement.ACTION_TIMING_MAP.WEBHOOK.includes(new_timing)) {
          treatment_flow.querySelectorAll("webhook-treatment").forEach(function(element) {
            element.parentNode.removeChild(element);
          });
        } 
        if(!PostTreatmentElement.ACTION_TIMING_MAP.REP_CODE.includes(new_timing)) {
          treatment_flow.querySelectorAll("rep-code-treatment").forEach(function(element) {
            element.parentNode.removeChild(element);
          });
        } 
        treatment_flow.action_timing = new_timing;
        treatment_flow.querySelectorAll("post-treatment-element").forEach(function(element) {
          element.parentNode.replaceChild(document.createElement("post-treatment-element"), element);
        });

        this.querySelector(":scope > .option_path .option_text").innerText = option.querySelector("select option:checked").text;

        return true;
      } else {
        return false;
      }
    } else {
      treatment_flow.action_timing = new_timing;
      treatment_flow.querySelectorAll("post-treatment-element").forEach(function(element) {
        element.parentNode.replaceChild(document.createElement("post-treatment-element"), element);
      });
      this.querySelector(":scope > .option_path .option_text").innerText = option.querySelector("select option:checked").text;
      return true;
    }
  }

  getIcon() {
    return 'fa-th'
  }

  static getType() {
    return "POST_TREATMENT"
  }

  getData() {
    let actions_array = [];

    let optionsContainer = this.querySelector(".post_menu_options");
    optionsContainer.children.forEach((item, index) => {
      let timing = item.getData() 
      actions_array.push(...this.querySelectorAll(":scope > post-treatment-flow")[index].getData(timing));
    });

    return actions_array;
  }

  validate() {
    let response = {requiredMissing: false, errorMessages: []};
    let optionsContainer = this.querySelector(".post_menu_options");
    let post_treatment_data = [];
    optionsContainer.children.forEach((item, index) => {
      item.classList.remove("error");
      if(item.getData() == "null") {
        item.classList.add("error");
        response.requiredMissing = true;
      }
      let validation_response = this.querySelectorAll(':scope > post-treatment-flow')[index].validate();
      if(validation_response.requiredMissing) {
        response.requiredMissing = true;
      } else if(item.getData() != "null") {
        Array.prototype.push.apply(post_treatment_data, this.querySelectorAll(':scope > post-treatment-flow')[index].getData(item.getData)); 
      }
      if(validation_response.requiredMissing || (validation_response.errorMessages != null && validation_response.errorMessages.length > 0)) {
        item.classList.add("error");
      }
      Array.prototype.push.apply(response.errorMessages, validation_response.errorMessages);
    });
    let seen = new Set();
    var hasDuplicates = post_treatment_data.some(function(action) {
        return action.action_id != null && seen.size === seen.add(action.action_id + "_" + action.action_timing).size;
    });
    if(hasDuplicates) {
      response.errorMessages.push("Has duplicate webhooks for the same condition.");
    }

    this.querySelector(":scope > .ct_post_action").classList.remove("error");
    if(response.requiredMissing || response.errorMessages.length > 0) {
      this.querySelector(":scope > .ct_post_action").classList.add("error");
    }
    return response;
  }

  isTarget() {
    return false;
  }

  connectedCallback() {
    let post_actions_count = 0
    if(this.child_actions != null) {
      this.child_actions.forEach(function(child_action) {
        if(child_action.action_timing != 1) { // Not immediate
          post_actions_count++;
        }
      });
    }
    this.innerHTML = 
      `
      <div class="col-sm-12 ct_show_post_action_container" style="text-align:center;${post_actions_count>0 ? 'display:none;' : ''}"}>
        <div class="ct_show_post_action" style="display:inline-block;height: 50px;width: 50px;color: #abb1b8; border: 2px solid #abb1b8;border-radius: 50%;font-size: 30px;margin-left: 2px;cursor: pointer;">+</div>
      </div>
      <div class="col-sm-12 ct_action ct_post_action" data-action_type=POST_ACTIONS style="${post_actions_count>0 ? '' : 'display:none;'}">
        <div class="panel panel-default">
          <h4>Post Treatment Conditions</h4>
          <div class="form-group">
            <div class="post_menu_options">
            </div>
            <div class="row">
              <div class="col-sm-12">
                <a class="btn btn-primary pull-right add_post_action">Add</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="option_path" style="display:none;">
        <div class="col-sm-12 ct_line">
          <div class="bottom_line"></div>
          <div class="ct_vertical_arrow"></div>
          <div class="option_text"></div>
          <div class="ct_vertical_arrow">
            <div class=arrow-down></div>
          </div>
        </div>
      </div>
    `;

    if(this.child_actions != null) {
      let action_map = {};
      this.child_actions.forEach(function(child_action, i) {
        if(child_action.action_timing != 1) { // Not immediate
          if(action_map[child_action.action_timing] != null) {
            action_map[child_action.action_timing].push(child_action.action)
          } else {
            action_map[child_action.action_timing] = [];
            action_map[child_action.action_timing].push(child_action.action)
          }
        }
      });
    
      let first_option = null;
      Object.keys(action_map).forEach(function(action_timing, i){
        let actions = action_map[action_timing];
        let optionsContainer = this.querySelector(".post_menu_options")
        let option = document.createElement("post-call-option");
        option.action_timing = parseInt(action_timing);
        if(i==0) first_option = option;

        let optionFlow = document.createElement("post-treatment-flow");
        optionFlow.action_timing = parseInt(action_timing);
        optionFlow.renderActions(actions);
        optionsContainer.appendChild(option);
        this.appendChild(optionFlow);
      }.bind(this));
      if(first_option != null) this.selectOption(first_option);
    }

    this.querySelector(".add_post_action").addEventListener("click", function() {
      let optionsContainer = this.querySelector(".post_menu_options")

      let option = document.createElement("post-call-option");
      let optionFlow = document.createElement("post-treatment-flow");
      optionsContainer.appendChild(option);
      optionFlow.action_timing = PostCallOption.ACTION_TIMINGS.NO_ANSWER.value;

      let treatmentElement = document.createElement("post-treatment-element");
      optionFlow.appendChild(treatmentElement);
      this.appendChild(optionFlow);
      this.selectOption(option);
    }.bind(this));
    
    this.querySelector(".ct_show_post_action").addEventListener("click", function() {
      this.querySelector(":scope > .ct_show_post_action_container").style.display = "none";
      this.querySelector(":scope > .ct_post_action").style.display = "block";
      this.querySelector(".add_post_action").click();
    }.bind(this));
  }
}

customElements.define('post-call-treatment', PostCallTreatment);

class PostCallOption extends HTMLElement {
  
  constructor() {
    super();
  }

  setSelected(is_selected) {
    this.selected = is_selected
    if(is_selected) {
      this.classList.add("selected");
    }
    else {
      this.classList.remove("selected");
    }
  }

  getData() {
    return this.action_timing;
  }

  connectedCallback() {
    this.innerHTML = `<div class="row" style="margin-bottom:5px; position:relative;">
          <div class="col-md-7">
              <select class="post_timing form-control">
                <option value=${PostCallOption.ACTION_TIMINGS.NO_ANSWER.value}>${PostCallOption.ACTION_TIMINGS.NO_ANSWER.name}</option>
                <option value=${PostCallOption.ACTION_TIMINGS.SALES_REP_ANSWER.value}>${PostCallOption.ACTION_TIMINGS.SALES_REP_ANSWER.name}</option>
                <option value=${PostCallOption.ACTION_TIMINGS.CALL_CONNECTED.value}>${PostCallOption.ACTION_TIMINGS.CALL_CONNECTED.name}</option>
                <option value=${PostCallOption.ACTION_TIMINGS.LEAD_HANGS_UP.value}>${PostCallOption.ACTION_TIMINGS.LEAD_HANGS_UP.name}</option>
                <option value=${PostCallOption.ACTION_TIMINGS.SALES_REP_HANGS_UP.value}>${PostCallOption.ACTION_TIMINGS.SALES_REP_HANGS_UP.name}</option>
                <option value=${PostCallOption.ACTION_TIMINGS.COMPLETE.value}>${PostCallOption.ACTION_TIMINGS.COMPLETE.name}</option>
              </select>
          </div>
          <div class="col-md-1 pull-right type">
            <a class="remove_post_menu_option pull-right"><span class="fa fa-minus"></span></a>
          </div>
          <div class="ct_arrow"></div>
        </div>`

    if(this.action_timing != null) {
      this.querySelector("select.post_timing").value = this.action_timing;
    } else {
      this.action_timing = this.querySelector("select.post_timing").value;
    }

    this.querySelector("select.post_timing").addEventListener("change", function() {
      let action_timing = parseInt(this.querySelector("select.post_timing").value);
      if (!this.closest("post-call-treatment").flowTimingChange(this, action_timing)) {
        this.querySelector("select.post_timing").value = this.action_timing;
      } else {
        this.action_timing = action_timing;
      }
    }.bind(this));

    this.addEventListener('click', function(event) {
      if(event.target.tagName != "SPAN" && event.target.tagName != "A") {
        this.closest("post-call-treatment").selectOption(this);
      }
    }.bind(this));

    this.querySelector('.remove_post_menu_option').addEventListener('click', function(event){
      this.closest("post-call-treatment").removeOption(this);
    }.bind(this));
  }
}

PostCallOption.ACTION_TIMINGS = {
    NO_ANSWER: {
      value: 2,
      name: "When Target does not Answer"
    },
    SALES_REP_ANSWER: {
      value: 3,
      name: "When Target answers but audio not connected"
    },
    CALL_CONNECTED: {
      value: 4,
      name: "When Target answers and audio is connected"
    },
    ANYONE_HANGS_UP: {
      value: 5,
      name: "When anyone hangs up"
    },
    LEAD_HANGS_UP: {
      value: 6,
      name: "When Caller hangs up first"
    },
    SALES_REP_HANGS_UP: {
      value: 7,
      name: "When Target hangs up first"
    },
    COMPLETE: {
      value: 8,
      name: "When call is complete"
    }
  };

customElements.define('post-call-option', PostCallOption);


class PostTreatmentFlow extends TreatmentFlow {
  constructor() {
    super()
  }

  replace(oldElement, action_type="") {
    let newElement = null;
    let addNewAction = false; // Some elments allow followup actions.
    let logo = ''
    switch(action_type) {
      case "play_audio":
        addNewAction = true;
        newElement = document.createElement('audio-action-treatment');
        break;
      case "sms":
        addNewAction = true;
        newElement = document.createElement('sms-treatment');
        break;
      case "webhook":
        addNewAction = true;
        newElement = document.createElement('webhook-treatment');
        break;
      case "rep_code":
        addNewAction = true;
        newElement = document.createElement('rep-code-treatment');
        break;
      case "post_treatment_done": 
        newElement = document.createElement('post-treatment-end');
        break;
      default:
        newElement = document.createElement('post-treatment-element');
    }

    if(newElement != null) {
      this.replaceChild(newElement, oldElement);
      if(addNewAction) {
        this.appendChild(document.createElement('post-treatment-element'))
      }
    } else {
      console.log("Error occured");
    }      
  }

  renderActions(actions) {

    actions.forEach(function(action, i) {
      let newElement = null;
      if(action.action_type == "SMS") {
        newElement = document.createElement('sms-treatment');
      } else if (action.action_type == "AUDIO") {
        newElement = document.createElement('audio-action-treatment');
      } else if (action.action_type == WebhookTreatment.getType() || action.action_type == WebhookTreatment.getEmailType()) {
        newElement = document.createElement('webhook-treatment');
      } else if (action.action_type == RepCodeTreatment.getType()) {
        newElement = document.createElement('rep-code-treatment');
      }
      newElement.action = action;
      this.appendChild(newElement);

      if(i+1 >= actions.length) {
        this.appendChild(document.createElement('post-treatment-end'))
      }
    }.bind(this));
  }

  getData(timing) {
    let actions_array = []
    this.children.forEach((element, i) => {
      let action_data = element.getData();
      if(action_data != null) {
        action_data.action_timing = timing;
        actions_array.push(action_data);
      }
    });
    return actions_array;
  }

  repCodeAlreadyRequested() {
    return this.querySelector('rep-code-treatment')
  }
}

customElements.define('post-treatment-flow', PostTreatmentFlow);

class PostTreatmentElement extends HTMLElement {

  constructor() {
    super();
    this.show_only_actions = false;
  }

  connectedCallback() {
    let current_action_timing = this.closest("post-treatment-flow").action_timing;
    let post_treatment_flow = this.closest("post-treatment-flow");
    this.innerHTML = 
    `
    <style>
      .fa-user-headset {
        content: url("data:image/svg+xml,%3Csvg width='22' height='24' viewBox='0 0 22 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15.7143 16.5H15.4688C14.8795 16.5 14.2902 16.6406 13.7009 16.8281C12.8661 17.1094 11.933 17.25 11 17.25C10.0179 17.25 9.08482 17.1094 8.25 16.8281C7.66071 16.6406 7.07143 16.5469 6.48214 16.5469H6.28571C2.79911 16.5469 0 19.2188 0 22.5C0 23.3438 0.6875 24 1.57143 24H20.4286C21.2634 24 22 23.3438 22 22.5C22 19.2188 19.1518 16.5 15.7143 16.5ZM2.40625 21.75C2.79911 20.0625 4.37054 18.7969 6.28571 18.75H6.48214C6.72768 18.75 7.07143 18.8438 7.46429 18.9844C8.59375 19.3125 9.77232 19.5 10.9509 19.5C12.1786 19.5 13.3571 19.3125 14.4866 18.9844C14.8795 18.8438 15.2232 18.75 15.4688 18.75H15.7143C17.5804 18.7969 19.1518 20.0625 19.5446 21.75H2.40625ZM2.70089 10.5C3.33929 10.5 3.83036 10.0312 3.83036 9.42188V9C3.83036 5.25 7.02232 2.20312 11 2.20312C14.9286 2.20312 18.1205 5.25 18.1205 9V9.60938C18.1205 11.3906 16.5982 12.8438 14.7321 12.8438H13.6027C13.4062 12 12.6205 11.3906 11.7366 11.3906H10.2143C9.13393 11.3906 8.29911 12.1875 8.29911 13.2188C8.29911 14.2031 9.13393 15.0469 10.2143 15.0469C10.2143 15.0469 10.2143 15.0469 10.2143 15H14.7321C17.875 15 20.3795 12.6094 20.4286 9.60938V9C20.4286 4.07812 16.1562 0 11 0C5.79464 0 1.57143 4.07812 1.57143 9V9.42188C1.57143 10.0312 2.0625 10.5 2.70089 10.5ZM11 6C12.7188 6.04688 14.0938 7.35938 14.1429 9C14.0938 9.5625 13.9464 10.0781 13.7009 10.5C14.0446 10.7344 14.3393 11.0156 14.5848 11.3438H14.7321C15.3705 11.3438 15.9107 11.0156 16.2054 10.5469C16.3527 10.0781 16.5 9.5625 16.5 9C16.5 6.14062 13.9955 3.75 11 3.75C7.95536 3.75 5.5 6.14062 5.5 9C5.5 10.3594 5.99107 11.5312 6.875 12.4688C7.07143 11.6719 7.5625 10.9688 8.25 10.5C8.00446 10.0781 7.85714 9.5625 7.85714 9C7.85714 7.35938 9.23214 6.04688 11 6Z' fill='%236B6B6B'/%3E%3C/svg%3E%0A");
      }
    </style>
    <div class="col-sm-12 ct_action" data-action_type=NEW>
      <div class="panel panel-default">
        <h4>Choose an Action</h4>
        ${PostTreatmentElement.ACTION_TIMING_MAP.PLAY_AUDIO.includes(current_action_timing) ? `
        <div class="col-sm-3">
          <div class="well" data-action_type=play_audio>Play Audio
          <i class="fa fa-headphones" style="width: 100%; font-size: 2em;"></i>
          </div>
        </div>
        ` : "" }
        ${PostTreatmentElement.ACTION_TIMING_MAP.SMS.includes(current_action_timing) ? `
        <div class="col-sm-3">
          <div class="well" data-action_type=sms>Text Message
          <i class="fa fa-comment" style="width: 100%; font-size: 2em;"></i>
          </div>
        </div>
        ` : "" }
        ${PostTreatmentElement.ACTION_TIMING_MAP.WEBHOOK.includes(current_action_timing) ? `
        <div class="col-sm-3">
          <div class="well" data-action_type=webhook>Integration
          <i class="fa fa-cloud-upload" style="width: 100%; font-size: 2em;"></i>
          </div>
        </div>
        ` : ""}
        ${PostTreatmentElement.ACTION_TIMING_MAP.REP_CODE.includes(current_action_timing) && !post_treatment_flow.repCodeAlreadyRequested() ? `
        <div class="col-sm-3">
          <div class="well" data-action_type=rep_code>Representive Code
          <i class="fa fa-user-headset" style="width: 100%; height: 21px;"></i>
          </div>
        </div>
        ` : ""}
        <div class="col-sm-3">
          <div class="well" data-action_type=post_treatment_done>Done
          <i class="fa fa-times-circle" style="width: 100%; font-size: 2em;"></i>
          </div>
        </div>
      `;
    let _this = this;
    this.querySelectorAll(".well").forEach(function(elem) {elem.addEventListener('click', function() {
      _this.closest("post-treatment-flow").replace(_this, this.dataset.action_type);
    });});
  }

  validate() {
    // For post treatments these are not required.
    return {requiredMissing: false, errorMessages: []};
  }

  getData() {
    return null;
  }
}

PostTreatmentElement.ACTION_TIMING_MAP = {
    PLAY_AUDIO: [PostCallOption.ACTION_TIMINGS.NO_ANSWER.value,
                PostCallOption.ACTION_TIMINGS.SALES_REP_ANSWER.value,
                PostCallOption.ACTION_TIMINGS.LEAD_HANGS_UP.value,
                PostCallOption.ACTION_TIMINGS.SALES_REP_HANGS_UP.value],
    SMS: [PostCallOption.ACTION_TIMINGS.NO_ANSWER.value,
                PostCallOption.ACTION_TIMINGS.SALES_REP_ANSWER.value,
                PostCallOption.ACTION_TIMINGS.CALL_CONNECTED.value,
                PostCallOption.ACTION_TIMINGS.LEAD_HANGS_UP.value,
                PostCallOption.ACTION_TIMINGS.SALES_REP_HANGS_UP.value,
                PostCallOption.ACTION_TIMINGS.COMPLETE.value],
    WEBHOOK: [PostCallOption.ACTION_TIMINGS.NO_ANSWER.value,
                PostCallOption.ACTION_TIMINGS.SALES_REP_ANSWER.value,
                PostCallOption.ACTION_TIMINGS.CALL_CONNECTED.value,
                PostCallOption.ACTION_TIMINGS.LEAD_HANGS_UP.value,
                PostCallOption.ACTION_TIMINGS.SALES_REP_HANGS_UP.value,
                PostCallOption.ACTION_TIMINGS.COMPLETE.value],
    REP_CODE: [PostCallOption.ACTION_TIMINGS.LEAD_HANGS_UP.value]
  };

customElements.define('post-treatment-element', PostTreatmentElement);

class PostTreatmentEnd extends TreatmentTarget {

  constructor() {
    super();
  }

  validate() {
    // For post treatments these are not required.
    return {requiredMissing: false, errorMessages: []};
  }

  getData() {
    return null;
  }

  connectedCallback() {
    this.innerHTML = 
    `<div class="col-sm-12 ct_action" data-action_type=DONE>
        <div class="panel panel-default">
            <h4>Done with Call Flow</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
            <div class="col-sm-12">
              <p>The call flow ends.</p>
            </div>
        </div>
      </div>
      `;
    super.connectedCallback();
  }
}

customElements.define('post-treatment-end', PostTreatmentEnd);